import * as ng from 'angular';
import ComponentRegistration from './component-registration';
import { SiteConfig, ISiteConfigService } from './site-config';
import { Exception, IException } from './exception';
import { Logger, ILogger } from './logger';
import { SetScrollHeight } from './set-scroll-height';
import './polyfills';

export {
    IApi,
    IAumfSettings,
    IClient,
    IConfig,
    IContact,
    ICustomerSettings,
    IImage,
    ILanguage,
    ILinkButton,
    IRegexValidations,
    IReserveParkingSettings,
    IService,
    ITokenizer
} from './interfaces';

let CoreModule = ng.module("app.core", [])
    .service(SiteConfig.name, SiteConfig.factory)
    .service(Exception.name, Exception.factory)
    .service(Logger.name, Logger.factory)
    .directive(SetScrollHeight.name, SetScrollHeight.factory);


export { ComponentRegistration, ISiteConfigService, IException, ILogger };
export default CoreModule;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/core/index.ts